export const breakpointsNumber = {
  '4k': 3840,
} as const;

export const breakpoints = Object.entries(breakpointsNumber).reduce(
  (acc, [key, value]) => ({ ...acc, [key]: `${value}px` }),
  {} as Record<keyof typeof breakpointsNumber, string>,
);
